import React from "react";

const LessonIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_14628_24734)">
        <path d="M22.3086 15.0909C22.3085 10.697 18.6916 7.13535 14.2308 7.13525C9.76982 7.13525 6.15306 10.697 6.15295 15.0909C6.15295 19.4849 9.76975 23.0466 14.2308 23.0466C18.6917 23.0465 22.3086 19.4849 22.3086 15.0909ZM23.4615 15.0909C23.4615 20.1116 19.3287 24.1817 14.2308 24.1818C9.13272 24.1818 5 20.1117 5 15.0909C5.00012 10.0703 9.13279 6 14.2308 6C19.3287 6.0001 23.4614 10.0703 23.4615 15.0909Z" />
        <path
          d="M25.2837 16.0057C25.1838 15.9806 25.0824 16.0408 25.0561 16.1407L24.4121 18.5908C24.327 18.8737 24.1568 19.1357 23.8909 19.2929C23.4335 19.5549 23.0186 19.4082 22.774 19.3139C20.4977 18.4965 18.7213 17.6896 17.296 17.48C16.8492 17.4171 14.8601 17.0189 13.8603 18.4231C13.2433 19.2824 13.0731 20.9277 13.7114 22.3109C14.5517 24.1448 16.3387 24.5849 16.9131 24.7316C18.7639 25.2137 21.2742 25.3709 22.9335 24.1658C24.4227 23.0759 24.9546 21.2944 25.0822 20.739L26.2243 16.4393C26.2514 16.3374 26.19 16.233 26.0881 16.2074L25.2837 16.0057Z"
          fill="#57CC99"
        />
        <path d="M28.931 6.3095L26.4236 15.8374L25.8656 15.6918L25.3076 15.5453L27.8159 6.01831L28.931 6.3095Z" />
      </g>
      <defs>
        <clipPath id="clip0_14628_24734">
          <rect
            width="24"
            height="20"
            fill="white"
            transform="translate(5 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LessonIcon;
